export { default } from "./useLazyReadingSkillsQuery";
